/*
 * Matches an empty tiptap JSON document.
 *
 * We use this instead of something like "" because we need to match the
 * tiptap JSON document format.
 *
 * We don't use 'convert_markdown_content_to_encoded_content("")' because it results
 * in a document with a single newline - if it merges with the user's content, it
 * generates a newline at the beginning of the document.
 */
export const INITIAL_NOTE_CONTENT_DOCUMENT_ENCODED_CONTENT = "AAA=";

export const TIPTAP_DEFAULT_YJS_NAMESPACE = "default";
